module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-termine-51b00e72106525d6a5c9a4a9aeac87a4.jpg";